import { useTranslation } from "next-i18next";
import InfoButton from "../../../component/design-system/InfoButton";

function HeaderInfoButton() {
  const { t } = useTranslation("product");
  return (
    <InfoButton
      placement="bottom"
      style={{ paddingLeft: 10, opacity: 0.7 }}
    >

      <p style={{
        textAlign: "left", whiteSpace: "pre-line", width: 272, fontSize: 15, fontWeight: 500,
      }}
      >
        {t("info_text_1")}
        <br />
        {t("info_text_2")}
        <br />
        {t("info_text_3")}
        <br />
        {t("info_text_4")}
      </p>
    </InfoButton>
  );
}

export default HeaderInfoButton;
